import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Aboutpages from "./components/pages/Aboutpages";

import './App.css';
import Contact from "./components/pages/Contact";
import UserAuthContextProvider from './contexts/UserAuthContext';
import ProtectedRouter from "./components/pages/ProtectedRouter";
import UserDashboard from './components/pages/UserDashboard';
import StudentFrom from "./components/pages/StudentFrom";
import Teacherpage from "./components/pages/Teacherpage";
import Terms from "./components/pages/Terms";
import Privacy from "./components/pages/Privacy";
import Refund from "./components/pages/Refund";
import Coursepage from "./components/pages/Coursepage";
import Printpage from "./components/pages/Printpage";
import Login from "./components/pages/Login";
import Signup from "./components/pages/Signup";
function App() {
  return (
    <BrowserRouter>
      <UserAuthContextProvider>
        <Routes>
          {/* Home page */}
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<Aboutpages />} />
          <Route path="/Contact-us" element={<Contact />} />
          <Route path="/StudentFrom" element={<StudentFrom />} />
          <Route path="/TeacherForm" element={<Teacherpage />} />
          <Route path="/Terms-condition" element={<Terms />} />
          <Route path="/course" element={<Coursepage />} />
          <Route path="/Refund" element={<Refund />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route axact path="/Login" element={<Login />} />
          <Route axact path="/_______wb______astha" element={<Signup />} />
          <Route path="/print_teacher_applicationfrom" element={<Printpage />} />
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route axact path="/UserDashboard/:userId" element={<ProtectedRouter> <UserDashboard /> </ProtectedRouter>} />

        </Routes>
        <Footer />
      </UserAuthContextProvider>
    </BrowserRouter>
  );
}

export default App;
